// @flow
import { get } from '../utils/api';

class AffordaPortalDetailService {
  getByPortalUserId(
    organizationId: string,
    propertyId: string,
    portalUserId: string,
    options?: Object,
  ): Promise<any> {
    return get(
      `/${organizationId}/${propertyId}/afforda-portal-details/portal-user/${portalUserId}`,
      options,
    );
  }
}

export default AffordaPortalDetailService;
